import React, { useEffect, useState } from 'react';
import { FaList } from 'react-icons/fa';

function TableOfContents({ quill }) {
  const [toc, setToc] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!quill) return;

    const generateTOC = () => {
      const contents = quill.getContents();
      const headings = [];
      let index = 0;

      contents.ops.forEach((op, i) => {
        if (op.attributes && op.attributes.header) {
          // Find the full text of the heading
          let headingText = op.insert;
          let j = i + 1;
          while (j < contents.ops.length && (!contents.ops[j].attributes || !contents.ops[j].attributes.header)) {
            headingText += contents.ops[j].insert;
            j++;
          }

          headings.push({
            id: `heading-${i}`,
            level: op.attributes.header,
            text: headingText.trim(),
            index: index
          });
        }
        index += op.insert.length;
      });

      setToc(headings);

      // Add IDs to the actual headings in the editor
      headings.forEach(heading => {
        quill.formatText(heading.index, 1, 'id', heading.id, 'api');
      });
    };

    generateTOC();
    quill.on('text-change', generateTOC);

    return () => {
      quill.off('text-change', generateTOC);
    };
  }, [quill]);

  const scrollToHeading = (index) => {
    if (quill) {
      quill.setSelection(index, 0);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div 
        className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center">
          <FaList className="text-gray-500 mr-2" />
          <h3 className="text-sm font-semibold text-gray-700">Table of Contents</h3>
        </div>
        <span className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}>▼</span>
      </div>
      {isOpen && (
        <ul className="p-3 space-y-1 max-h-64 overflow-y-auto">
          {toc.map((item) => (
            <li
              key={item.id}
              className={`cursor-pointer text-sm hover:text-blue-600 transition-colors duration-150 pl-${(item.level - 1) * 4}`}
              onClick={() => scrollToHeading(item.index)}
            >
              <span className="mr-2 text-gray-400">{item.level}.</span>
              {item.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default TableOfContents;